import { Icon, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { F0TagBalance } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

interface PeriodBalanceTagProps {
  currentPeriodAmount: number
  lastPeriodAmount: number
}

const calculatePercentageDifference = (current: number, last: number): number => {
  if (last === 0) return 0
  return ((current - last) / last) * 100
}

const formatPercentage = (percentage: number): string => {
  return i18n.t('expenses_v2.reports.expenses_by_approval_status.common.change_from_last_period', {
    percentage: percentage >= 0 ? '+' + percentage.toFixed(1) : percentage.toFixed(1),
  })
}

const formatNotApplicableSpecialCase = (): string => {
  return i18n.t('expenses_v2.reports.expenses_by_approval_status.common.not_applicable_change')
}

const PeriodBalanceTag = ({ currentPeriodAmount, lastPeriodAmount }: PeriodBalanceTagProps) => {
  const notApplicableSpecialCase = lastPeriodAmount === 0
  const formattedText = notApplicableSpecialCase
    ? formatNotApplicableSpecialCase()
    : formatPercentage(calculatePercentageDifference(currentPeriodAmount, lastPeriodAmount))
  const [open, toggle] = useToggle(false)

  return (
    <>
      <F0TagBalance status="neutral" text={formattedText} />
      {notApplicableSpecialCase && (
        <Tooltip.Alt
          open={open}
          toggle={toggle}
          attachment="bottom center"
          label={i18n.t(
            'expenses_v2.reports.expenses_by_approval_status.common.not_applicable_change_explanation'
          )}
        >
          <Icon.Small icon="info-circle" color="grey800" />
        </Tooltip.Alt>
      )}
    </>
  )
}

export default PeriodBalanceTag
